const links = [
  { label: "Home", anchor: "#home" },
  { label: "About", anchor: "#about" },
  { label: "Work", anchor: "#work" },
  { label: "Skills", anchor: "#skills" },
  { label: "Contact", anchor: "#contact" },
];

export default links;
